import { Component, OnInit, ViewChild, HostListener, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AppSettings } from '../../app.settings';
import { Settings } from '../../app.settings.model';
import { MenuService } from '../../theme/components/menu/menu.service';
import { environment } from '../../../environments/environment';
import { DadosService } from '../../db/dados.service';
import {MatDialog, MatDialogConfig} from '@angular/material';
import {PedidosNovosDialogComponent} from '../pedidos-novos-dialog/pedidos-novos-dialog.component'
import { CarrinhoItemsModel } from '../../../../models/carrinhoItems.model';
import { UsersService } from '../../../../models/usuarios.service';

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss'],
  providers: [MenuService]
})
export class PagesComponent implements OnInit,OnDestroy {

  @ViewChild('sidenav') sidenav: any;
  public settings: Settings;
  public menus = ['vertical', 'horizontal'];
  public menuOption: string;
  public menuTypes = ['default', 'compact', 'mini'];
  public menuTypeOption: string;
  public isStickyMenu: boolean = false;
  public lastScrollTop: number = 0;
  public showBackToTop: boolean = false;
  public toggleSearchBar: boolean = false;
  private defaultMenu: string; //declared for return default menu when window resized 
  public scrolledContent: any;

  public site: any;
  private pedidoModel : CarrinhoItemsModel

  get logo() {
    return environment.site.logo;
  }
  get nomeLoja() {
    return environment.site.nome;
  }

  constructor(
    public appSettings: AppSettings, 
    public router: Router, 
    private menuService: MenuService,
    private pedidosNovosDialog : MatDialog, 
    private usersService : UsersService) 
    {
      this.settings = this.appSettings.settings;
      this.site = environment.site.nome;
      this.pedidoModel = new CarrinhoItemsModel(usersService.usuarioClass.dbConn,usersService)
      this.pedidoModel.pedidoClass.snapshot(
      function(elem)
      { 
        return elem
        .where('estado',"==",0)
        .where('fornecedor','==',(usersService.fornecedor?usersService.fornecedor:0)); 
      },
      (data : Array<any>)=>
      { 
        if(data && (data.length > 0))
        { 
          this.exibeSinoPedidosNovos(data)
        }
      },
      true) 
   }

  ngOnInit() {
    if (window.innerWidth <= 768) {
      this.settings.menu = 'vertical';
      this.settings.sidenavIsOpened = false;
      this.settings.sidenavIsPinned = false;
    }
    this.menuOption = this.settings.menu;
    this.menuTypeOption = this.settings.menuType;
    this.defaultMenu = this.settings.menu;
  }

  public routerActivate(event, outlet) {
  }

  private exibeSinoPedidosNovos(pedidos : any)
  {
      let img : HTMLImageElement = <HTMLImageElement>document.getElementById('img-sino')
      if(img) return
      this.efeitoSonoroSino()
      img  = document.createElement('img')
      img.id = 'img-sino'
      let config = new MatDialogConfig()
      config.data = pedidos
      img.onclick = ()=> this.pedidosNovosDialog.open(PedidosNovosDialogComponent,config)   
      document.getElementsByTagName('body')[0].appendChild(img)   
  }

  tocouAudio:number = 0;
  private efeitoSonoroSino()
  {  
    if (this.tocouAudio==0){
    this.pedidoModel.playAudio('novoPedido.wav')  
    this.tocouAudio++;
    const intervalId =  setInterval(()=>{
      this.pedidoModel.playAudio('novoPedido.wav')
      let img : HTMLImageElement = <HTMLImageElement>document.getElementById('img-sino')
      if(!img)
        clearInterval(intervalId)     
    },6000)
  }
  }

  ngAfterViewInit() {
    setTimeout(() => { this.settings.loadingSpinner = false }, 300)
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (!this.settings.sidenavIsPinned) {
          this.sidenav.close();
        }
        if (window.innerWidth <= 768) {
          this.sidenav.close();
        }
      }
    });
    if (this.settings.menu == "vertical")
      this.menuService.expandActiveSubMenu(this.menuService.getVerticalMenuItems());
  }

  public chooseMenu() {
    this.settings.menu = this.menuOption;
    this.defaultMenu = this.menuOption;
    this.router.navigate(['/']);
  }

  public chooseMenuType() {
    this.settings.menuType = this.menuTypeOption;
  }

  public changeTheme(theme) {
    this.settings.theme = theme;
  }

  public toggleSidenav() {
    this.sidenav.toggle();
  }



  public onPsScrollY(event) {
    this.scrolledContent = event.target;
    (this.scrolledContent.scrollTop > 300) ? this.showBackToTop = true : this.showBackToTop = false;
    if (this.settings.menu == 'horizontal') {
      if (this.settings.fixedHeader) {
        var currentScrollTop = (this.scrolledContent.scrollTop > 56) ? this.scrolledContent.scrollTop : 0;
        (currentScrollTop > this.lastScrollTop) ? this.isStickyMenu = true : this.isStickyMenu = false;
        this.lastScrollTop = currentScrollTop;
      }
      else {
        (this.scrolledContent.scrollTop > 56) ? this.isStickyMenu = true : this.isStickyMenu = false;
      }
    }
  }

  public scrollToTop() {
    var scrollDuration = 200;
    var scrollStep = -this.scrolledContent.scrollTop / (scrollDuration / 20);
    var scrollInterval = setInterval(() => {
      if (this.scrolledContent.scrollTop != 0) {
        this.scrolledContent.scrollBy(0, scrollStep);
      }
      else {
        clearInterval(scrollInterval);
      }
    }, 10);
    if (window.innerWidth <= 768) {
      this.scrolledContent.scrollTop = 0;
    }
  }

  @HostListener('window:resize')
  public onWindowResize(): void {
    if (window.innerWidth <= 768) {
      this.settings.sidenavIsOpened = false;
      this.settings.sidenavIsPinned = false;
      this.settings.menu = 'vertical'
    }
    else {
      (this.defaultMenu == 'horizontal') ? this.settings.menu = 'horizontal' : this.settings.menu = 'vertical'
      this.settings.sidenavIsOpened = true;
      this.settings.sidenavIsPinned = true;
    }
  }

  public closeSubMenus() {
    let menu = document.querySelector(".sidenav-menu-outer");
    if (menu) {
      for (let i = 0; i < menu.children[0].children.length; i++) {
        let child = menu.children[0].children[i];
        if (child) {
          if (child.children[0].classList.contains('expanded')) {
            child.children[0].classList.remove('expanded');
            child.children[1].classList.remove('show');
          }
        }
      }
    }
  }

  public siteName() {
    return '';
  }

  public siteLogo() {
    return 'NC';
  }

  removerSino()
  {
    const img = document.getElementById('img-sino')
    if(img)
      document.getElementsByTagName('body')[0].removeChild(img)
  }
  ngOnDestroy()
  {
    //remove o sino quando da log off 
    if(this.isLoginRoute())
     this.removerSino()
  }

  isLoginRoute()
  {
    let location = window.location.pathname
    return location.endsWith('login')
  }

}